import React from 'react';
import { 
  Megaphone, 
  Palette, 
  Headphones, 
  Video, 
  Camera, 
  TrendingUp, 
  Film, 
  MessageCircle 
} from 'lucide-react';
import { Skill, Language } from '../types';

const Skills: React.FC = () => {
  const coreSkills: Skill[] = [
    { icon: <Megaphone className="w-6 h-6 text-text-light" />, name: "Digital Marketing" },
    { icon: <Palette className="w-6 h-6 text-text-light" />, name: "Figma" },
    { icon: <Headphones className="w-6 h-6 text-text-light" />, name: "Zendesk" },
    { icon: <Video className="w-6 h-6 text-text-light" />, name: "CapCut" },
    { icon: <Palette className="w-6 h-6 text-text-light" />, name: "Canva" },
    { icon: <Camera className="w-6 h-6 text-text-light" />, name: "Photo Editing" },
    { icon: <TrendingUp className="w-6 h-6 text-text-light" />, name: "Insight Analysis" },
    { icon: <Film className="w-6 h-6 text-text-light" />, name: "DaVinci Resolve" },
    { icon: <MessageCircle className="w-6 h-6 text-text-light" />, name: "Communication" }
  ];

  const languages: Language[] = [
    { name: "Italian", level: "Native", percentage: 100 },
    { name: "English", level: "C1", percentage: 85 },
    { name: "German", level: "B2", percentage: 65 },
    { name: "Portuguese", level: "A2", percentage: 25 }
  ];

  return (
    <section id="skills" className="py-24 bg-white">
      <div className="container mx-auto px-6">
        <h2 className="text-4xl font-semibold text-center mb-16">
          Skills & Languages
        </h2>
        <div className="grid md:grid-cols-2 gap-16 items-start">
          <div>
            <h3 className="text-2xl font-semibold text-center mb-8">
              Core Skills
            </h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 text-center">
              {coreSkills.map((skill, index) => (
                <div
                  key={index}
                  className="card p-4 rounded-xl flex flex-col items-center justify-center"
                >
                  {skill.icon}
                  <h4 className="font-medium text-sm mt-2">{skill.name}</h4>
                </div>
              ))}
            </div>
          </div>
          <div>
            <h3 className="text-2xl font-semibold text-center mb-8">Languages</h3>
            <div className="space-y-4">
              {languages.map((language, index) => (
                <div key={index}>
                  <p className="font-medium">
                    {language.name}
                    <span className="text-sm text-slate-500 float-right">
                      {language.level}
                    </span>
                  </p>
                  <div className="w-full bg-gray-200 rounded-full h-2 mt-1">
                    <div
                      className="h-2 rounded-full bg-accent-secondary transition-all duration-1000"
                      style={{ width: `${language.percentage}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills; 